import { LatLng, LatLngBounds, LatLngExpression } from "leaflet";

export const atlMapCenter: LatLngExpression = new LatLng(33.6398, -84.4269);

export const atlMapBounds = new LatLngBounds(
  [33.62945, -84.456153], // southwest
  [33.652244, -84.40032], // northeast
);
